import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

const events = ['load', 'mousemove', 'mousedown', 'click', 'scroll', 'keypress']

const SessionLogout = ({ children }) => {
  const navigate = useNavigate()
  let timer

  const handleSessionTimeOut = () => {
    timer = setTimeout(() => {
      resetTimer()

      Object.values(events).forEach((item) => {
        window.removeEventListener(item, resetTimer)
      })

      logOut()
    }, 15 * 60 * 1000)
  }

  const resetTimer = () => {
    if (timer) clearTimeout(timer)
  }

  useEffect(() => {
    resetTimer()
    handleSessionTimeOut()
  })

  Object.values(events).forEach((item) => {
    window.addEventListener(item, () => {
      resetTimer()
      handleSessionTimeOut()
    })
  })

  const logOut = () => {
    navigate('/auth/logout')
  }

  return children
}

export default SessionLogout
